import CloseIcon from '@mui/icons-material/Close';
import { AccordionDetails, Button, Grid, IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setConfirmExitValue } from 'src/store/confirmExitValue';

const PersonnelPresent: React.FunctionComponent<any> = ({
  personnelPresent,
  setPersonnelPresent,
  isDisable,
  setIsChanged,
  setIsDataUpdate,
  setIsSaveEnable,
  disable
}) => {
  let count = 0;
  const [row, setRow] = useState(personnelPresent.length);
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(true);

  const [listtemp, setListTemp] = useState<any>([]);

  useEffect(() => {
    const data = personnelPresent?.map((item: any) => {
      count++;
      return {
        ...item,
        unique_id: count
      };
    });

    setListTemp(data);
    setRow(personnelPresent.length);
  }, [personnelPresent]);

  const handleAdd = () => {
    setRow((prev: number) => prev + 1);
    const templist = listtemp;
    const newAdded = {
      unique_id: row + 1
    };

    setListTemp([...templist, newAdded]);
    setIsChanged(true);
  };

  const handleChange = (unique_id: number, e: any) => {
    const temp = listtemp.map((item: { unique_id: number }) => {
      if (item.unique_id === unique_id) {
        return {
          ...item,
          [e.target.name]: e.target.value
        };
      } else {
        return item;
      }
    });
    setListTemp(temp);
    setPersonnelPresent(temp);
    setIsChanged(true);
    setIsDataUpdate(true);
    setIsSaveEnable(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleClose = (unique_id: any) => {
    setToggle(false);
    const filteredCRF = listtemp.filter((ele: { unique_id: any }) => ele.unique_id !== unique_id);
    setListTemp(filteredCRF);
    setPersonnelPresent(filteredCRF);
  };

  useEffect(() => {
    setToggle(true);
  }, [listtemp]);
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        {toggle &&
          listtemp.map((item: any) => {
            return (
              <Grid item md={12} key={item.unique_id}>
                <Grid container spacing={2} mb={1.25}>
                  <Grid item xs>
                    <Grid container spacing={2}>
                      <Grid item md={4}>
                        <TextField
                          name="stdy_imvrp_personnel_name"
                          label="Name"
                          variant="standard"
                          value={item?.stdy_imvrp_personnel_name}
                          onChange={e => handleChange(item.unique_id, e)}
                          disabled={!isDisable || disable}
                          inputProps={{ maxLength: 100 }}
                          InputLabelProps={{ shrink: item.stdy_imvrp_personnel_name }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          name="stdy_imvrp_personnel_role"
                          label="Role"
                          variant="standard"
                          value={item?.stdy_imvrp_personnel_role}
                          onChange={e => handleChange(item.unique_id, e)}
                          disabled={!isDisable || disable}
                          inputProps={{ maxLength: 100 }}
                          InputLabelProps={{ shrink: item.stdy_imvrp_personnel_role }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <TextField
                          name="stdy_imvrp_personnel_affiliation"
                          label="Affiliation"
                          variant="standard"
                          value={item?.stdy_imvrp_personnel_affiliation}
                          onChange={e => handleChange(item.unique_id, e)}
                          disabled={!isDisable || disable}
                          inputProps={{ maxLength: 100 }}
                          InputLabelProps={{ shrink: item.stdy_imvrp_personnel_affiliation }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <IconButton
                      sx={{ mt: 2 }}
                      onClick={() => handleClose(item.unique_id)}
                      disabled={!isDisable || disable}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}

        <Grid item md={12}>
          <Button variant="contained" onClick={handleAdd} disabled={!isDisable || disable}>
            Add
          </Button>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default PersonnelPresent;
